import { createFileRoute } from "@tanstack/react-router";
import { Left } from "@repo/icons";
import { ServicePackageEnum } from "@repo/lib";
import { graphql } from "@repo/graphql-types/gql";
import { Page } from "@/components/page";
import { HeaderRoot, HeaderUpButton, HeaderTitle } from "@/components/header";
import { SubscribedAssist } from "@/components/subscribed-assist-pro";
import { validatePackageAccess } from "@/lib/assist-package-guard";
import { AsyncDataWrapper } from "@/components/async-data-wrapper";
import { useGraphQL } from "@/hooks/use-graphql";

const SubscribedAssistProQuery = graphql(
  /* GraphQL */ `
  query SubscribedAssistProQuery($codPacoteServicos: Int!) {
    servicePackage: pacotesServicos_by_pk(codPacoteServicos: $codPacoteServicos) {
      pacotesServicosPreco {
        ...SubscribedAssistFragment
      }
    }
  }
  `,
);

export const SubscribedAssistPage = (): JSX.Element => {
  const queryResult = useGraphQL(SubscribedAssistProQuery, {
    codPacoteServicos: ServicePackageEnum.Pro.valueOf(),
  });

  const { data } = queryResult;

  return (
    <>
      <HeaderRoot>
        <HeaderUpButton icon={Left} align="start" />
        <HeaderTitle title="Livance Assist Pro" />
      </HeaderRoot>
      <Page>
        <AsyncDataWrapper {...queryResult}>
          {data?.servicePackage?.pacotesServicosPreco ? (
            <SubscribedAssist data={data.servicePackage.pacotesServicosPreco} />
          ) : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/assist/subscribed-assist/")({
  component: SubscribedAssistPage,
  beforeLoad: ({ context }) => {
    const { user } = context;
    validatePackageAccess({ user, packageService: ServicePackageEnum.Pro });
  },
});
